// extracted by css-extract-rspack-plugin
export default {"InviteCollaboratorsDrawer":"sputnik__InviteCollaboratorsDrawer__PybhY","inviteCollaboratorsDrawer":"sputnik__InviteCollaboratorsDrawer__PybhY"};